export const TICKET_STATUS = {
  active: 'Active',
  inactive: 'Inactive',
  resolved: 'Resolved',
};

export const TICKET_PRIORITY = {
  critical: 'Critical',
  elevated: 'Elevated',
  low: 'Low',
  normal: 'Normal',
};

export const TICKET_STATUS_OPTIONS = [
  {
    label: TICKET_STATUS.active,
    value: TICKET_STATUS.active,
  },
  {
    label: TICKET_STATUS.inactive,
    value: TICKET_STATUS.inactive,
  },
  {
    label: TICKET_STATUS.resolved,
    value: TICKET_STATUS.resolved,
  },
];

export const TICKET_PRIORITY_OPTIONS = [
  {
    label: TICKET_PRIORITY.low,
    value: TICKET_PRIORITY.low,
  },
  {
    label: TICKET_PRIORITY.normal,
    value: TICKET_PRIORITY.normal,
  },
  {
    label: TICKET_PRIORITY.critical,
    value: TICKET_PRIORITY.critical,
  },
  {
    label: TICKET_PRIORITY.elevated,
    value: TICKET_PRIORITY.elevated,
  },
];
